import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_taxsmart-11/artifacts/ujxod0n6_LOGO%20DT-MAX.jpg" 
              alt="PROTAXESPLUS Logo" 
              className="h-12 w-auto mb-4 bg-white rounded p-1"
            />
            <h3 className="text-xl font-bold mb-4">{companyInfo.name}</h3>
            <p className="text-gray-400">
              Votre partenaire de confiance pour tous vos besoins fiscaux et comptables.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Liens rapides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors duration-200">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contactez-nous</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-white hover:underline transition-colors duration-200"
                  title="Cliquez pour envoyer un email"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="text-gray-400 hover:text-white hover:underline transition-colors duration-200"
                  title="Cliquez pour appeler"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <a 
                  href="https://www.google.com/maps/dir/?api=1&destination=6500+Route+Transcanadienne,+Saint-Laurent,+QC+H4T+1X4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white hover:underline transition-colors duration-200"
                  title="Cliquez pour obtenir l'itinéraire sur Google Maps"
                >
                  <div>{companyInfo.address}</div>
                  <div>{companyInfo.suite}</div>
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <span className="text-gray-400">{companyInfo.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} {companyInfo.name}. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
